import React from 'react';
import ReactTypingEffect from 'react-typing-effect';

const typingTextSettings = {
  text: [
    'Independent contractor compliance',
    'Contingent workforce management',
    'Direct sourcing',
  ],
  speed: 50,
  eraseDelay: 2000,
  typingDelay: 1000,
  cursorClassName: 'typing-cursor',
};

export default function MainSection() {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-title-box">
          <p className="hero-caption">
            World-Class Technology with Obsessive Customer Care for
          </p>
          <h1 className="hero-title">Corporate</h1>
          <h2 className="hero-subtitle">Talent Acquisition</h2>
          <p className="solutions-block">
            <span>Solutions for : </span>
            <strong className="solutions-animation">
              <ReactTypingEffect {...typingTextSettings} />
            </strong>
          </p>
        </div>
      </div>
    </section>
  );
}
